import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const generateHeadingClassNames = ({
  extraClass,
  isUnderlined,
}) => classNames(
  'heading',
  {
    [`${extraClass}`]: extraClass,
    'heading--underline text--center': isUnderlined,
  },
);

// tests do not currently exist for react components
// istanbul ignore next
const Heading = ({
  level,
  children,
  extraClass,
  isUnderlined,
  id = null,
  ...rest
}) => {
  const HeadingLevel = level ? `h${level}` : 'h3';

  if (!children) {
    return null;
  }

  return (
    <HeadingLevel
      id={id}
      className={generateHeadingClassNames({ extraClass, isUnderlined })}
      {...rest}
    >
      {children}
    </HeadingLevel>
  );
};

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  extraClass: PropTypes.string,
  isUnderlined: PropTypes.bool,
  id: PropTypes.string,
};

Heading.level = [1, 2, 3, 4, 5, 6];

export default Heading;
